<template>
    <b-notification
        v-if="isExpiring && isRenewable"
        class="vertically-aligned horizontally-spaced"
        :closable="false"
    >
        Tenancy expires {{ remainingTime }}. Would you like to request a renewal?

        <b-button
            rounded
            size="is-small"
            @click.prevent="requestRenewal()"
        >
            Request renewal
        </b-button>
    </b-notification>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapState('tenancyProperty', [
            'tenancy',
        ]),
        ...mapGetters('tenancyProperty', [
            'isExpiring',
            'isRenewable',
            'remainingTime',
        ]),
    },

    methods: {
        requestRenewal() {
            this.$store.dispatch('tenancyProperty/requestRenewal');

            this.$buefy.toast.open({
                duration: 5000,
                message: 'Message has been sent to Agent to request a tenancy renewal.',
                type: 'is-success',
            });
        },
    },
};
</script>
